import requestFunctions from "../../functions/requestFunctions";


export const state = {
  COMPANIES_ITEM: {},
  COMPANIES_LIST: [],
  COMPANIES_TABLE_DATA: [],
  COMPANIES_LIST_DATA: [],
  COMPANIES_TOTAL_ROWS: 0
}

export const getters = {
  GET_COMPANIES_ITEM: (state) => {
    return state.COMPANIES_ITEM;
  },
  GET_COMPANIES_LIST: (state) => {
    return state.COMPANIES_LIST;
  },
  GET_COMPANIES_TABLE_DATA: (state) => {
    return state.COMPANIES_TABLE_DATA;
  },
  GET_COMPANIES_LIST_DATA: (state) => {
    return state.COMPANIES_LIST_DATA;
  },
  GET_COMPANIES_TOTAL_ROWS: (state) => {
    return state.COMPANIES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_COMPANIES_ITEM(state, item) {
    state.COMPANIES_ITEM = item;
  },

  UPDATE_COMPANIES_LIST(state, list) {
    
    state.COMPANIES_LIST = list.data;

    state.COMPANIES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.COMPANIES_TABLE_DATA = [];
    state.COMPANIES_LIST_DATA = [];

    list.forEach(el => {

      state.COMPANIES_TABLE_DATA.push({
        'name'    : el.name,
        'inn'     : el.inn,
        'kpp'     : el.kpp,
        'phone'   : el.phone ? el.phone : '',
        'account_balance' : el.account_balance ? el.account_balance + ' руб.' : '0 руб.',
        'uuid'    : el.uuid
      });

      state.COMPANIES_LIST_DATA.push({
        id: el.id,
        name: el.name,
        account_id: el.account_id,
      });
    });
  },
}

export const actions = {

  async FETCH_COMPANIES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/companies/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COMPANIES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_COMPANIES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/companies';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COMPANIES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_COMPANIES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/companies';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_COMPANIES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/companies/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_COMPANIES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/companies/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}